/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBookingCreateInput } from "../../entities/models/BookingCreateInput";
import { z } from "zod/v4";

export const modelsBookingCreateInputSchema = z.object({
    "barber_id": z.optional(z.int()),
"scheduled_start_time": z.string(),
"selected_emoji": z.optional(z.string()),
"service_id": z.int(),
"user_id": z.string()
    }) as unknown as z.ZodType<ModelsBookingCreateInput>